module.exports = __webpack_public_path__ + "static/media/01.18bc11a3.mp3";